import React, { useState, useEffect , useRef} from "react";
import { useParams } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import { Accordion, AccordionTab } from "primereact/accordion";

import { useDispatch, useSelector } from "react-redux";

import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/DemandeClap.scss";



import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { ExerciceService } from "../../../service/ExerciceService";


export const DemandeLayout = ({ Notice, Formulaire, libellePrestation }) => {

    const { mode } = useParams();
    const [activeIndex, setActiveIndex] = useState([]);
    const [displayBasic, setDisplayBasic] = useState(false);
    const toast = useRef(null);

    const user = useSelector((state) => state.usager.user);
    const actionSociale = useSelector((state) => state.actionSociale);
  
    const [disabledForm, disableForm] = useState(true);

  
    let fraisEnvoi;
    let createMode = "create";
    let editMode = "edit";
    let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

    const [hiddenNoticeButton, hideNoticeButton] = useState(editMode === mode ? true : false);

    const text =<div><p>Politique de protection des données à caractère personnel</p>
            <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
            <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
            <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
            <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
            <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
            <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>

    const logoutRemoveData = (e) => {
        chequeCultureService.logOut().then((res) => {
        console.log(res);
        });
        handleAnnuler();
    };
    
    const handleAnnuler = () => {
        chequeCultureService.redirectEaLegacy();
    };


    const chequeCultureService = new ChequeCultureService();
    const linkService = new LinkProviderService();
    const exerciceService = new ExerciceService();


  useEffect(() => {
    initActiveIndex();
  }, []);


  useEffect(() => {
    if(createMode === mode) disabledForm ? setActiveIndex([0]) : setActiveIndex([1]);
    if(editMode === mode) setActiveIndex([1]);
  }, [disabledForm]);




  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([0]);
    if(editMode === mode) setActiveIndex([1]);
  };

  const handleConfirm = (e) => {
    disableForm(e);
    hideNoticeButton(!e);
  };

  return (
    <div className="grid cld-width">
      <div className="col-12">
        <Toast ref={toast} position="top-center" className="toast-position" />
        <div
          className="no_shadow_no_border card "
          style={{ display: displayBasic ? "block" : "none" }}
        >
          <div className="border-round border-1 surface-border p-4">
            <Skeleton width="100%" height="400px"></Skeleton>
            <div className="flex justify-content-between mt-3">
              <Skeleton width="10rem" height="2rem"></Skeleton>
              <Skeleton width="10rem" height="2rem"></Skeleton>
            </div>
          </div>
        </div>

        <div
          className="no_shadow_no_border card "
          style={{ display: !displayBasic ? "block" : "none" }}
        >
          <ChequeCultureLegacy />

          <nav aria-label="breadcrumb" class="pt-3">
             <ol class="breadcrumb"><li class="breadcrumb-item">
             <a href={linkService.getRetourEaAccueilAgent()} target="_self">Espace Agent</a></li>
             <li class="breadcrumb-item">
            <a href={linkService.getRetourEaMembrePrestation()} target="_self">Prestations et Formulaires</a></li>
            <li aria-current="page" class="breadcrumb-item active">Demande d'une prestation</li>
           </ol>
          </nav>
          <h1 className="page-header" style={{ color: "#676767" }}>
            PRESTATIONS - {localStorage.getItem('exerciceEnCours')}
            <br/>
            {libellePrestation}
          </h1>
          <form
            action=""
            id="espaceAgent"
            method="POST"
            name="formCheque"
            className="form-horizontal cld-form-padding"
          >

                <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <AccordionTab header="COMPRENDRE LA PRESTATION" >
                        <Notice onConfirm={(e) => handleConfirm(e)}/>
                    </AccordionTab>

                    <AccordionTab header="ENVOYER UNE DEMANDE (paiement uniquement par carte bancaire)" disabled={true}>
                        <Formulaire/>
                    </AccordionTab>
                </Accordion>
                </form>
            </div></div></div>
  );
};
